import { RollfiCompany } from '@hone-automation/common';
import { useQuery } from '@tanstack/react-query';
import { makeGetRollfiCompanies } from 'main/factories/usecases/rollfi';

export const useGetRollfiCompanies = (locationId: string | undefined, enabled: boolean = true) => {
  return useQuery<RollfiCompany[]>({
    queryKey: ['rollfiCompanies', locationId],
    queryFn: async () => {
      if (!locationId) {
        throw new Error('Location ID is required');
      }
      const service = makeGetRollfiCompanies();
      const result = await service.getRollfiCompanies({ locationId });

      if ('error' in result) {
        throw new Error(result.error || 'Failed to fetch Rollfi companies');
      }

      return result as RollfiCompany[];
    },
    enabled: enabled && !!locationId,
    retry: 1,
  });
};
